import React from 'react'
import { StyledInput } from './Inputs.styles';
import createInputWithValidation from './createInputWithValidation';


const TextInputDisabled = ({ name, value, onChange, onBlur, placeholder, isRequired }) => (
  <StyledInput
    id={name}
    name={name}
    value={value}
    onChange={onChange}
    type="text"
    onBlur={onBlur}
    placeholder={placeholder}
    required={isRequired}
    disabled={true}
  />
);

TextInputDisabled.defaultProps = {
  isRequired: false
};

export default createInputWithValidation('text')(TextInputDisabled);